import { Typography } from "antd";
import styled from "styled-components";

export const HeaderDiv = styled.div`
  height: 50px;
  background-color: blue;
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: linear-gradient(to right, #42005a, white);
`;

export const LogoImage = styled.img`
  height: 30px;
  width: auto;
`;

export const PlatformName = styled(Typography)`
  font-family: "Quicksand", "Roboto", sans-serif;
  color: aliceblue;
  font-size: 20px;
  font-weight: 600;
`;
